import { Form } from 'react-bootstrap'
import * as Common from '../../../../utils/Common'
import { labelDetailStyle } from './DcDetailStyles'

const StyledDetailField = ({ label, value, col = 12, withCopy = false }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div className="position-relative">
        <Form.Control
          type="text"
          value={value || '-'}
          readOnly
          className="px-3 bg-light"
          style={{
            fontSize: '0.9rem',
            height: '40px',
            borderRadius: '8px',
            border: '1px solid #ced4da',
            cursor: 'not-allowed',
            paddingRight: withCopy ? '35px' : '15px'
          }}
        />
        {withCopy && value && value !== '-' && (
          <span
            className="position-absolute text-muted"
            style={{
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer'
            }}
            onClick={() => {
              navigator.clipboard.writeText(value)
              Common.showPopUpSuccessMessage('Copied to clipboard!')
            }}
          >
            <i className="fa-regular fa-copy"></i>
          </span>
        )}
      </div>
    </Form.Group>
  )
}

export default StyledDetailField
